import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { FinishedProjectsSettings } from "@/data/models/Settings";
import { createDefaultFinishedProjectsSettings } from "@/data/models/Client";

const name = "finishedProjectsSettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class FinishedProjectsSettingsVuexModule extends VuexModule {
  finishedProjectsSettings: FinishedProjectsSettings = createDefaultFinishedProjectsSettings();

  @Mutation
  setFinishedProjectsSettings(finishedProjectsSettings: FinishedProjectsSettings) {
    this.finishedProjectsSettings = finishedProjectsSettings;
  }

  @Mutation
  clear() {
    this.finishedProjectsSettings = createDefaultFinishedProjectsSettings();
  }
}

export const FinishedProjectsSettingsModule = getModule(FinishedProjectsSettingsVuexModule, store);
